"use client";

import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { useNavigation } from "@/hooks/useNavigation";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

const LANDING = "/hair/brand/lp/core/real-growth-guarantee/";
const LABEL = "Learn More";

const HomepageRggBanner = ({ className = "" }: { className?: string }) => {
  const navigate = useNavigation();

  const handleClick = () => {
    GA4.onMarketingCtaClicked({
      destination: LANDING,
      module_location: "mid_fold",
      text: LABEL,
      type: "banner",
    });
    navigate(LANDING);
  };

  return (
    <section
      className={cn(
        "cursor-pointer h-[187px] md:h-[286px] lg:h-[500px] bg-cover bg-center bg-no-repeat",
        "bg-[url('https://images.ctfassets.net/0rbfqd9c4jdo/66xnha5vqPPwEao4FZ3eI8/9272c35a379a1229c549517c62732fb5/rgg-hp-mobile__1_.jpg')]",
        "lg:bg-[url('https://images.ctfassets.net/0rbfqd9c4jdo/3j37dkDBZmQq7LtKwaLmHQ/4c5c15386dbeb74edc432ae8a19e5433/rgg-hp__1_.jpg')]",
        className
      )}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleClick();
      }}
      aria-label="Results in 6 months or your money back. Learn More"
      role="link"
      tabIndex={0}
    >
      <div className="h-full flex lg:items-start justify-center p-3 lg:pt-[70px]">
        <div className="flex items-center justify-center">
          <div className="flex-shrink-0 w-[149px] h-[149px] md:w-[190px] md:h-[190px] lg:h-[322px] lg:w-[322px]">
            <Picture
              src="https://images.ctfassets.net/0rbfqd9c4jdo/1yq2Qrbvad7ekKWktqf9fP/7dd5cac96f2e4c623c767d13247af30d/RGG_Badge.png"
              alt="Nutrafol Real Growth Guarantee. Results or Refund."
              width={322}
              height={322}
            />
          </div>
          <div className="flex flex-col gap-4 items-start">
            <TextElementNova
              text="Results in 6 months<br class='hidden md:block' /> or<br class='md:hidden' /> your money back.<sup>∞</sup>"
              element="h2"
              className="text-nova-base-white"
              classes={{
                default: "Body-30-Dia-Strong",
                768: "Subtitle-20-Dia-Strong",
                1024: "Subtitle-20-Dia-Strong",
              }}
            />
            <ButtonNova
              label={LABEL}
              icon="Right"
              level="Tertiary"
              copyClassName="text-nova-base-white"
              tabIndex={-1}
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomepageRggBanner;
